import { render } from "./PaginationComponent.vue?vue&type=template&id=40a648f6&scoped=true"
import script from "./PaginationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&setup=true&lang=js"

import "./PaginationComponent.vue?vue&type=style&index=0&id=40a648f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a648f6"],['__file',"src/components/roleSelect/PaginationComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40a648f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40a648f6', __exports__)) {
    api.reload('40a648f6', __exports__)
  }
  
  module.hot.accept("./PaginationComponent.vue?vue&type=template&id=40a648f6&scoped=true", () => {
    api.rerender('40a648f6', render)
  })

}


export default __exports__